export const PARTNER_TYPE_LABELS = {
  HOLD_CO: 'HoldCo',
  AGENCY: 'Agency',
  CURATOR: 'Curator',
  PORTFOLIO: 'Portfolio'
} as const;

export const PARTNER_TYPE_TAG_CLASSES = {
  HOLD_CO: 'partner-type-holdco',
  AGENCY: 'partner-type-agency',
  CURATOR: 'partner-type-curator',
  PORTFOLIO: 'partner-type-portfolio'
} as const;

export const PARTNER_ROLE_NAMES = {
  ADMIN: 'Partner Admin',
  TRADER: 'Partner Trader',
  VIEWER: 'Partner Viewer'
} as const;

export type PartnerRoleName = typeof PARTNER_ROLE_NAMES[keyof typeof PARTNER_ROLE_NAMES];

export const PARTNER_ROLE_DESCRIPTIONS: Record<PartnerRoleName, string> = {
  [PARTNER_ROLE_NAMES.ADMIN]: 'Full access within the assigned scope, including managing portfolios and users.',
  [PARTNER_ROLE_NAMES.TRADER]: 'Can create and edit deals within the assigned scope, but cannot delete deals or manage users and settings.',
  [PARTNER_ROLE_NAMES.VIEWER]: 'Read-only access within the assigned scope.'
};

export const SCOPE_PARTNER_PREFIX = 'partner:';
export const SCOPE_PORTFOLIO_PREFIX = 'portfolio:';

export const SCOPE_TAGS = {
  portfolio: { label: PARTNER_TYPE_LABELS.PORTFOLIO, cssClass: PARTNER_TYPE_TAG_CLASSES.PORTFOLIO }
} as const;

/** Portfolio tooltip for the deals list filter; the deal form adds the account hint. */
export const PORTFOLIO_FIELD_TOOLTIP =
  'Portfolios group an account\'s deals and are created on the account\'s Portfolios tab.';
export const PORTFOLIO_FORM_FIELD_TOOLTIP = `${PORTFOLIO_FIELD_TOOLTIP} Select an account to see its portfolios.`;
